import config from '@config'

import { createApiClient } from '@shared/apiClient/createApiClient'

const MAPPED_ENV: Record<string, string> = {
  localhost: config.env,
}

const getEnvToUrlMap = (service: string) => ({
  plus: `https://api.partneringone.informaconnect.com/${service}/`,
  partneringone: `https://api.partneringone.informaconnect.com/${service}/`,
  green: `https://api.green.prod.ponedev.net/${service}/`,
  blue: `https://api.blue.prod.ponedev.net/${service}/`,
})

const DEFAULT_ENV = 'partneringone'

export default (service: string) => {
  return createApiClient(MAPPED_ENV, getEnvToUrlMap(service), DEFAULT_ENV, `https://api.{env}.ponedev.net/${service}/`)
}
